export default "__VITE_ASSET__DD2O4g4K__"